import { MagnifyingGlass, X } from "@phosphor-icons/react"
import { inputVariant } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface PatientsSearchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string
  onClear: () => void
  autoFocus?: boolean
  ref?: React.Ref<HTMLInputElement>
}

export const PatientsSearch = ({ onClear, autoFocus = false, ...props }: PatientsSearchProps) => {
  return (
    <div className="ml-auto">
      <div className="relative lg:w-75" data-testid="patient-search">
        <input
          id="search"
          className={cn(inputVariant(), "peer bg-surface hover:bg-surface focus:bg-surface h-12 pt-0 pr-9 pl-4")}
          autoComplete="off"
          aria-autocomplete="none"
          autoFocus={autoFocus}
          {...props}
        />
        <span
          className="hover:bg-surface-hovered visible absolute top-1/2 right-10 -translate-y-1/2 cursor-pointer rounded-full p-1 transition-all peer-placeholder-shown:invisible"
          onClick={onClear}>
          <X className="text-on-surface-subdued h-6 w-6 cursor-pointer" />
        </span>
        <label htmlFor="search" className="absolute top-1/2 right-2 -translate-y-1/2">
          <MagnifyingGlass className="text-on-surface-subdued" />
        </label>
      </div>
    </div>
  )
}
